import { z } from 'zod';
import type { Dimensions } from 'Shared/posters/types';


export const defaultThemeWidth = 400;
export const defaultThemeHeight = 400;


/* A theme sizes every poster that belongs to it, so its dimensions are compulsory: parsing
   here is what lets the poster builder take a plain Dimensions rather than a maybe-width and
   a maybe-height. */
export const themeDimensions = z.object({
	width: z.number().int().positive(),
	height: z.number().int().positive(),
});


/* Reads a theme's dimensions out of the loose width/height a read aggregate surfaces, failing
   loudly rather than letting a sizeless theme reach the builder. */
export function readThemeDimensions(width: unknown, height: unknown): Dimensions
{
	return themeDimensions.parse({width, height});
}


/* What is wrong with a poster's act range, if anything. An absent max means no upper limit rather
   than a mistake, and an absent min lets any max stand, so the one wrong pair is a max its own
   minimum has passed. */
export function actRangeError(minActs: number|undefined, maxActs: number|undefined)
{
	if (minActs != undefined && maxActs != undefined && maxActs < minActs)
		return 'Max acts is less than min acts';

	return undefined;
}
